<script lang="ts">
  import { getWrapperStyles } from './helpers/sections-helper';
  import { Button, Paragraph, Heading, Wrapper } from './components';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;

  $: ({ borderRadius } = settings);
</script>

<Wrapper style="background:var(--vlt-lp-background);">
  {#if properties}
    <div
      class="section-container {properties.imageAlignment === 'left'
        ? 'reverse'
        : ''}"
      style="font-family: var(--vlt-lp-paragraph-font);"
      id={properties.anchor}
    >
      <div class="wrapper" style="{getWrapperStyles()};">
        <div class="content">
          <div
            class="text {properties.imageAlignment === 'left' ? 'reverse' : ''}"
          >
            {#if properties.heading}
              <Heading
                type={'h2'}
                css={'margin-bottom:50px;color:var(--vlt-lp-text);'}
              >
                {@html properties.heading}
              </Heading>
            {/if}

            {#if properties.text}
              <Paragraph css={'color:var(--vlt-lp-text);'}>
                {@html properties.text}
              </Paragraph>
            {/if}

            {#if properties.button.active}
              <Button
                {borderRadius}
                section="about us"
                buttonType={properties.button.link_type}
                buttonLink={properties.button.link}
                buttonTitle={properties.button.label}
              />
            {/if}
          </div>

          <div
            class="image {properties.imageAlignment === 'left'
              ? 'reverse'
              : ''}"
          >
            <img
              src={properties.image}
              alt="about-us-img"
              style=""
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  {/if}
</Wrapper>

<style>
  .section-container {
    display: flex;
    justify-content: flex-end;
  }
  .content {
    flex-wrap: wrap;
    width: auto;
    display: flex;
    align-items: center;
    grid-gap: 25px;
  }
  .image img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 2.5px;
  }
  .text {
    order: 1;
    flex: 1;
    padding: 0px 60px 15px 15px;
    word-break: break-word;
  }
  .image {
    max-width: 590px;
    min-width: 400px;
    order: 1;
    flex: 2;
    margin-left: 50px;
    height: 100%;
    overflow: hidden;
    max-height: 600px;
  }

  .reverse.section-container {
    justify-content: flex-start;
  }
  .reverse.text {
    order: 2;
  }
  .reverse.image {
    margin-left: 0;
    margin-right: 30px;
  }
  @media screen and (max-width: 1026px) {
    .section-container {
      height: auto;
    }
    .text {
      margin: 0;
    }
    .text {
      padding: 0;
      min-width: 100%;
    }
    .image,
    .reverse.image {
      margin: 0;
      min-width: 100%;
      max-height: 400px;
    }
  }
  @media screen and (max-width: 767px) {
    .wrapper {
      padding: 0 15px !important;
    }
  }
  @media screen and (max-width: 640px) {
    .text {
      text-align: center !important;
    }
  }
</style>
